import { useQuery, useMutation } from "@tanstack/react-query";
import { knowledgeService } from "@/services/knowledgeService";

export function usePersonalpediaEntries(q = "") {
  return useQuery({ queryKey: ["personalpedia", "entries", q], queryFn: () => knowledgeService.entries(q) });
}

export function useAskPersonalpedia(options = {}) {
  return useMutation({ mutationFn: knowledgeService.ask, ...options });
}

export function useLearningMap() {
  return useQuery({ queryKey: ["personalpedia", "learning-map"], queryFn: knowledgeService.learningMap });
}
